import React from 'react';
import ListItem from '@mui/material/ListItem';
import Skeleton from '@mui/material/Skeleton';
import ListItemText from '@mui/material/ListItemText';

const GhostItem = () => {
    return (
        <ListItem disablePadding>
            <ListItemText
                sx={{ padding: '8px 12px' }}
                secondary={
                    <>
                        <Skeleton
                            variant="text"
                            width={200}
                            sx={{ fontSize: '13px' }}
                        />
                        <Skeleton
                            variant="text"
                            sx={{ fontSize: '13px' }}
                            width={200}
                        />
                    </>
                }
            >
                <Skeleton
                    variant="text"
                    sx={{ fontSize: '14px' }}
                    width={120}
                />
            </ListItemText>
        </ListItem>
    );
};

export default GhostItem;
